import { logout } from '../slices/authSlice';
import storageHelper from '../../common/utils/storageHelper';
import { trackEvent } from '../../utils/analytics';

const apiMiddleware =
  ({ dispatch, getState }) =>
  (next) =>
  async (action) => {
    const { method } = action?.payload || {};
    if (method) {
      action.payload.methodRequestState = 'requested';
      next(action); // Proceed with the modified action

      const baseUrl = process.env.REACT_APP_API_URL;
      const fullUrl = `${baseUrl}${method.url}`;

      // COMMENTED OUT: Authentication disabled - no token required
      // Get auth state from Redux store
      // const authState = getState().auth.authState;
      // const token = authState?.tokens.accessToken;

      const headers = {
        'Content-Type': 'application/json',
        'x-meta': storageHelper.get('$meta'),
        'Access-Control-Allow-Origin': '*',
      };

      // Create AbortController for timeout handling
      const controller = new AbortController();
      let timeoutId;

      try {
        // COMMENTED OUT: Authorization header disabled - all API calls are public
        // if (token) {
        //   headers.Authorization = `Bearer ${token || ''}`;
        // }

        // Set up timeout to abort request after 20 seconds
        timeoutId = setTimeout(() => {
          controller.abort();
        }, 20000);

        const response = await fetch(fullUrl, {
          method: method.action,
          headers,
          body: method.action.toLowerCase() === 'get' ? undefined : JSON.stringify(action.payload?.params || {}),
          signal: controller.signal,
        });

        // Clear timeout on successful response
        clearTimeout(timeoutId);

        // Check for unauthorized status before parsing JSON
        if (response.status === 401) {
          dispatch(logout());
          action.payload.error = { message: 'Unauthorized access' };
          action.payload.methodRequestState = 'finished';
          next(action);
          return;
        }

        const data = await response.json();
        if (response.ok) {
          action.payload.result = data;
        } else {
          action.payload.error = data;
        }
        action.payload.methodRequestState = 'finished';
      } catch (error) {
        // Clear timeout on error
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        // Check if error is due to timeout (AbortError)
        if (error.name === 'AbortError') {
          trackEvent('api_timeout', {
            error: 'Request timed out after 20 seconds',
            url: fullUrl,
            method: method.action,
            payload: JSON.stringify(action.payload),
            timeout: '20000ms',
          });
          action.payload.error = { message: 'Request timed out after 20 seconds' };
        } else {
          trackEvent('api_error', {
            error: `Error: ${error?.message || 'Unknown error occurred'}`,
            url: fullUrl,
            method: method.action,
            payload: JSON.stringify(action.payload),
          });
          action.payload.error = { message: error?.message || 'Unknown error occurred' };
        }
        action.payload.methodRequestState = 'finished';
      } finally {
        // Ensure timeout is cleared in all cases
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        action.payload.methodRequestState = 'finished';
      }
      next(action); // Proceed with the modified action after fetch
    } else {
      next(action);
    }
  };

export default apiMiddleware;
